<template>
  <page-view :is-loading="isLoading">
    <template #header>
      <base-header
        title="Live"
        has-intro
        :subtitle="video.title"
        @title="handleBackToListing"
        @back="handleBackToListing"
      >
        <template #info v-if="infoPage">
          <span v-html="infoPage" />
        </template>
        <template #actions>
          <!-- actions -->
          <base-btn
            :data-intro="$t('message.introJS.common.hls')"
            type="tertiary"
            icon="mdi-link-variant"
            @click="
              showLink(),
                handleSnackbar($t('message.hlsCopiedLink')),
                handleShowLink(video.video_hls)
            "
          />
          <base-btn
            v-if="!isPlayerLiveState"
            :data-intro="$t('message.introJS.common.performance')"
            type="secondary"
            @click="
              showPerformance(),
                handleSnackbar($t('message.pages.video.clipboardPerformance')),
                handleShowLink(textMetadata)
            "
          >
            Performance
          </base-btn>
          <base-btn
            v-if="isStreamingRightNow"
            :data-intro="$t('message.introJS.newLive.restream')"
            type="secondary"
            @click="openRestreamModal"
          >
            Restream
          </base-btn>
          <base-btn
            :data-intro="$t('message.introJS.common.embed')"
            @click="showEmbed"
          >
            Embed
          </base-btn>
          <base-btn
            v-if="liveStatus !== 'online'"
            type="tertiary"
            icon="mdi-dots-vertical"
            @click="showDots"
          />
        </template>
      </base-header>
    </template>

    <template #content>
      <!-- content -->
      <v-row no-gutters>
        <v-col cols="12">
          <v-card width="100%" height="100%" flat class="rounded-lg">
            <v-card
              v-if="isLoading"
              class="d-flex flex-row justify-center align-center"
              height="550px"
              width="100%"
              flat
            >
              <v-progress-circular :size="80" color="primary" indeterminate />
            </v-card>
            <v-form ref="form" v-model="valid" lazy-validation v-else>
              <v-row no-gutters style="min-height: 85vh">
                <v-col cols="6" class="primary-col">
                  <v-row>
                    <v-col
                
                      ref="player"
                      :data-intro="$t('message.introJS.newLive.preview')"
                      cols="12"
                      class="pr-10"
                    >
                      <v-card
                        v-if="
                          (video.status === 'CONVERTING' ||
                            video.status === 'FAILED' ||
                            video.status === 'DRAFT') &&
                          !isPlayerLiveState
                        "
                        class="d-flex flex-column justify-center align-center"
                        height="300px"
                        width="530px"
                      >
                        <template
                          v-if="
                            video.status === 'CONVERTING' ||
                            video.status === 'DRAFT'
                          "
                        >
                          <template
                            v-if="
                              Math.abs(
                                new Date(video.created_at) - new Date()
                              ) /
                                36e5 >
                              3
                            "
                          >
                            <span
                              v-if="
                                video.status === 'CONVERTING' &&
                                Math.abs(
                                  new Date(video.created_at) - new Date()
                                ) /
                                  36e5 <
                                  48
                              "
                              class="px-12 caption noIbar"
                            >
                              {{
                                $t(
                                  'message.pages.videoEditModal.videoConvertingText2'
                                )
                              }}
                              <br />
                              {{
                                $t(
                                  'message.pages.videoEditModal.videoConvertingText3'
                                )
                              }}
                            </span>
                            <span
                              v-else-if="video.status === 'DRAFT'"
                              class="px-12 caption noIbar"
                            >
                              {{ $t('message.processingError') }}. <br />
                              {{ $t('message.verifyFileFormat') }}.
                            </span>
                            <span v-else>
                              <v-row align="center" justify="center">
                                <span class="red--text text-subtitle-1">
                                  <v-icon size="20" color="red">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                  {{ $t('message.processingError') }}
                                </span>
                              </v-row>
                            </span>
                          </template>
                          <span
                            v-else-if="
                              Math.abs(
                                new Date(video.created_at) - new Date()
                              ) /
                                36e5 >
                              24
                            "
                          >
                            <v-row align="center" justify="center">
                              <span class="red--text text-subtitle-1">
                                <v-icon size="20" color="red">
                                  mdi-alert-circle-outline
                                </v-icon>
                                {{ $t('message.processingError') }}
                              </span>
                            </v-row>
                          </span>
                          <span v-else class="pb-4 text-h5 noIbar">
                            {{
                              $t(
                                'message.pages.videoEditModal.videoConvertingText'
                              )
                            }}
                          </span>
                        </template>
                        <template v-else>
                          <v-row align="center" justify="center">
                            <span class="red--text text-subtitle-1">
                              <v-icon size="20" color="red">
                                mdi-alert-circle-outline
                              </v-icon>
                              {{ $t('message.processingError') }}
                            </span>
                          </v-row>
                        </template>
                      </v-card>
                      <v-card flat v-else>
                        <span v-if="errors.videoDoesNotExist">
                          <v-card
                            class="d-flex flex-column justify-center align-center"
                            flat
                            height="300px"
                            width="530px"
                          >
                            <span class="red--text">
                              <v-row align="center" justify="center">
                                <span class="red--text text-subtitle-1">
                                  <v-icon
                                    height="20"
                                    color="red"
                                    class="d-inline-block mt-n1"
                                  >
                                    mdi-alert-circle-outline
                                  </v-icon>
                                  {{ $t('message.videoDoesNotExist') }}
                                </span>
                              </v-row>
                            </span>
                          </v-card>
                        </span>
                        <v-card
                          v-else-if="!isLandscapeOrientation"
                          style="margin: 0 auto"
                          flat
                          max-width="calc((100vh - 5rem) / 1.77778)"
                        >
                          <template v-if="konva.file && konva.img.image">
                            <div class="konva__container">
                              <v-stage
                                ref="stage"
                                class="konva__stage"
                                :config="konva.stage"
                                @mousedown="updateTransformer"
                                @touchstart="updateTransformer"
                              >
                                <v-layer ref="layer">
                                  <v-image
                                    :config="konva.img"
                                    @dragend="handleTransformEnd"
                                    @transformend="handleTransformEnd"
                                  />
                                  <v-transformer ref="transformer" />
                                </v-layer>
                              </v-stage>
                              <span class="konva__player" v-html="embedPage" />
                            </div>
                          </template>
                          <span v-else v-html="embedPage" />
                        </v-card>
                        <template v-else-if="!loadings.endLive">
                          <template v-if="konva.file && konva.img.image">
                            <div class="konva__container">
                              <v-stage
                                ref="stage"
                                class="konva__stage"
                                :config="konva.stage"
                                @mousedown="updateTransformer"
                                @touchstart="updateTransformer"
                              >
                                <v-layer ref="layer">
                                  <v-image
                                    :config="konva.img"
                                    @dragend="handleTransformEnd"
                                    @transformend="handleTransformEnd"
                                  />
                                  <v-transformer ref="transformer" />
                                </v-layer>
                              </v-stage>
                              <span class="konva__player" v-html="embedPage" />
                            </div>
                          </template>
                          <span v-else v-html="embedPage" />
                        </template>
                        <v-card
                          v-else
                          style="height: 279px; box-shadow: none"
                          class="d-flex justify-center align-center"
                        >
                          <v-progress-circular
                            size="35"
                            width="3"
                            color="primary"
                            indeterminate
                          />
                        </v-card>
                      </v-card>
                      <v-row
                        v-if="!isLoading"
                        class="px-0 pt-2 pb-0 d-flex justify-space-between"
                        no-gutters
                        style="max-height: 40px"
                      >
                        <v-col
                          v-if="
                            serverStatus === 'online' &&
                            liveStatus === 'offline'
                          "
                          class="d-flex align-center"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="float: left; background-color: #4caf50"
                          />
                          {{ $t('message.pages.newLive.waitingStreaming') }}
                        </v-col>
                        <v-col
                          v-else-if="
                            (serverStatus === 'pending' ||
                              serverStatus === 'offline') &&
                            liveStatus === 'offline'
                          "
                          class="d-flex align-center"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="
                              background-color: #2196f3;
                              float: left;
                              animation: provisioning 1.2s infinite;
                            "
                          />
                          {{ $t('message.pages.newLive.provisioningServer') }}
                          {{ countDown }}
                        </v-col>
                        <v-col
                          v-else-if="
                            serverStatus === 'online' &&
                            liveStatus === 'online' &&
                            liveBytesIn === undefined
                          "
                          class="d-flex align-center"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="
                              background-color: rgb(189 189 189);
                              float: left;
                            "
                          />
                          {{ $t('message.pages.newLive.thereIsNoData') }}
                        </v-col>
                        <v-col
                          v-else-if="
                            liveStatus === 'online' && serverStatus === 'online'
                          "
                          class="d-flex align-center pa-0"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="background-color: #ff5252; float: left"
                          />
                          LIVE&nbsp;<span style="min-width: 80px">{{
                            timeCounter
                          }}</span>
                          <v-chip
                            color="red"
                            style="height: 17px; color: white"
                            class="ml-1"
                            x-small
                          >
                            {{ streamDetails.height }}p/{{
                              streamDetails.frame_rate
                            }}fps
                          </v-chip>
                        </v-col>
                        <v-col
                          v-else-if="liveStatus === 'finished' && !videoId"
                          class="d-flex align-center"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="
                              background-color: #1867c0;
                              float: left;
                              animation: provisioning 1.2s infinite;
                            "
                          />
                          {{ $t('message.pages.newLive.generatingVideoId') }}
                        </v-col>
                        <v-col
                          v-else-if="
                            (liveStatus === 'finished' ||
                              liveStatus === 'finished_imported') &&
                            isPlayerLiveState
                          "
                          class="d-flex align-center"
                          style="height: 40px"
                        >
                          <span
                            class="circle"
                            style="background-color: #1867c0; float: left"
                          />
                          {{ $t('message.pages.newLive.convertingVideo') }}
                        </v-col>
                        <v-col
                        
                          v-if="
                            liveKbps !== null &&
                            previousBytes !== null &&
                            previousTime !== null &&
                            serverStatus === 'online' &&
                            liveStatus === 'online'
                          "
                          class="d-flex align-center justify-end live-info"
                          style="height: 40px"
                        >
                          <v-icon
                            v-if="viewers"
                            size="large"
                            color="var(--v-brand-base);"
                            class="mb-0 mr-1"
                          >
                            mdi-eye-outline
                          </v-icon>
                          <div v-if="viewers" class="mr-5">
                            {{ viewers }}
                          </div>
                          <div>
                            {{
                              liveKbps
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                            }}
                            Kbps
                          </div>
                          <span
                            :class="liveTransmissionStatus"
                            class="is-tag ml-2"
                          />
                        </v-col>
                      </v-row>
                      <v-col
                        v-if="
                          serverStatus === 'online' &&
                          liveStatus === 'online' &&
                          liveBytesIn === undefined
                        "
                        cols="12"
                        class="mb-0 pb-0 px-0"
                      >
                        <v-btn
                          :disabled="loadings.endLive"
                          :loading="loadings.endLive"
                          color="primary"
                          outlined
                          @click="handleEndLive"
                          >{{ $t('message.pages.newLive.endLive') }}</v-btn
                        >
                      </v-col>
                    </v-col>
                    <v-col
                      cols="12"
                      class="pb-2 pr-10 pt-0 container-title-description"
                    >
                      <v-text-field
                        ref="title"
                        v-model="video.title"
                        :placeholder="$t('message.addTitle')"
                        :rules="[
                          rules.required,
                          rules.maxLength,
                          rules.minLength,
                        ]"
                        :class="{ inputActive: 'title' === activeInput }"
                        required
                        color="primary"
                        outlined
                        hide-details
                        @blur="handleEdit"
                        @focus="inputBeingEdited('title')"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="cancelEdit"
                              >
                                mdi-close
                              </v-icon>
                            </template>
                            <span>
                              {{ $t('message.pages.video.cancel') }}
                            </span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-if="!videoId"
                                v-bind="attrs"
                                v-on="on"
                                @click="handleSaveName()"
                              >
                                mdi-check
                              </v-icon>
                              <v-icon
                                v-else
                                v-bind="attrs"
                                v-on="on"
                                @click="handleEdit()"
                              >
                                mdi-check
                              </v-icon>
                            </template>
                            <span>
                              {{ $t('message.pages.video.save') }}
                            </span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-0 pr-10 container-title-description"
                    >
                      <v-textarea
                        ref="description"
                        v-if="videoId"
                        v-model="video.description"
                        :placeholder="$t('message.add')"
                        :error="optionalDescription"
                        :error-messages="descriptionErrMsg"
                        :class="{ inputActive: 'description' === activeInput }"
                        outlined
                        dense
                        color="primary"
                        auto-grow
                        @focus="inputBeingEdited('description')"
                        @blur="handleEdit"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="cancelEdit"
                              >
                                mdi-close
                              </v-icon>
                            </template>
                            <span>
                              {{ $t('message.pages.video.cancel') }}
                            </span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="handleEdit"
                              >
                                mdi-check
                              </v-icon>
                            </template>
                            <span>
                              {{ $t('message.pages.video.save') }}
                            </span>
                          </v-tooltip>
                        </template>
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="mt-3 second-col">
                  <v-row
                  
                    class="mb-5 ml-3 mr-2 bottom-navigation-playerConfig"
                    style="border-bottom: 1px solid #66666659"
                  >
                    <v-bottom-navigation
                      v-if="isStreamingRightNow"
                      v-model="value"
                      color="primary"
                      background-color="background"
                      style="justify-content: left; box-shadow: none"
                      grow
                    >
                      <v-btn>
                        <span style="font-size: 16px">LIVE</span>
                      </v-btn>
                    </v-bottom-navigation>

                    <!-- tabs -->
                    <v-bottom-navigation
                      v-else
                      v-model="value"
                      background-color="background"
                      color="primary"
                      style="justify-content: left; box-shadow: none"
                      grow
                    >
                      <!-- tabs::player -->
                      <v-btn>
                        <span style="font-size: 16px">{{
                          $t('message.pages.video.player')
                        }}</span>
                      </v-btn>

                      <!-- tabs::analytics -->
                      <v-btn>
                        <span style="font-size: 16px">{{
                          $t('message.pages.video.metrics')
                        }}</span>
                      </v-btn>
                    </v-bottom-navigation>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <!-- tab::video-player -->
                      <v-scroll-x-transition mode="out-in" hide-on-leave>
                        <v-card
                          v-if="value === 0 && !isStreamingRightNow"
                          flat
                          tile
                          class="d-flex flex-column"
                        >
                          <video-player :videoId="videoId" />
                        </v-card>
                      </v-scroll-x-transition>

                      <!-- tab::live-player -->
                      <v-scroll-x-transition mode="out-in" hide-on-leave>
                        <v-card
                          v-if="isStreamingRightNow && value === 0"
                          flat
                          tile
                          class="d-flex flex-column"
                          :data-intro="$t('message.introJS.newLive.settings')"
                        >
                          <live-player
                            :liveStatus="liveStatus"
                            :viewers="viewers"
                            :liveInfo="liveInfo"
                            :scheduled="scheduled"
                            :serverStatus="serverStatus"
                            :showScheduled="showScheduled"
                            :timeLeft="timeLeft"
                            :scheduled_at="scheduled_at"
                            :handleInitNow="handleInitNow"
                            :loadings="loadings"
                            :errors="errors"
                            :defaultThumbnail="defaultThumbnail"
                            :imageError="imageError"
                            :newThumbnail="newThumbnail"
                            :handleChangeThumbnail="handleChangeThumbnail"
                            :successfulChangedThumb="successfulChangedThumb"
                          />
                        </v-card>
                      </v-scroll-x-transition>

                      <!-- tab::live-metrics -->
                      <v-scroll-x-transition mode="out-in" hide-on-leave>
                        <v-card
                          v-if="!isStreamingRightNow && value === 1"
                          flat
                          tile
                          class="d-flex flex-column"
                        >
                          <live-metrics
                            :isStreamingRightNow="isStreamingRightNow"
                            :serverStatus="serverStatus"
                            :liveStatus="liveStatus"
                            :timeLeft="timeLeft"
                            :errors="errors"
                            :liveInfo="liveInfo"
                            :lastVerificationServer="lastVerificationServer"
                            :isLive="true"
                            :streamDetails="streamDetails"
                            :customVideoId="videoId"
                            :videoPlayer="videoPlayerUrl"
                            :videoHls="video.video_hls"
                          />
                        </v-card>
                        <v-card
                          v-if="isStreamingRightNow && value === 1"
                          flat
                          tile
                          class="d-flex flex-column"
                        >
                          <live-metrics
                            :isStreamingRightNow="isStreamingRightNow"
                            :serverStatus="serverStatus"
                            :liveStatus="liveStatus"
                            :timeLeft="timeLeft"
                            :errors="errors"
                            :liveInfo="liveInfo"
                            :lastVerificationServer="lastVerificationServer"
                            :viewers="viewers"
                            :isLive="true"
                            :streamDetails="streamDetails"
                            :videoPlayer="videoPlayerUrl"
                            :videoHls="video.video_hls"
                          />
                        </v-card>
                      </v-scroll-x-transition>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card>

          <form
            ref="downloadForm"
            method="post"
            :action="downloadUrl"
            style="display: none"
          >
            <input
              ref="downloadInput"
              name="Authorization"
              :value="authToken"
              type="hidden"
            />
          </form>
        </v-col>
      </v-row>

      <!-- dialogs -->
      <embed-video
        v-if="showMenuEmbed"
        :startTime="startTime"
        :timeVideo="timeVideo"
        :videoId="videoId"
        :showMenuEmbed="showMenuEmbed"
        :embedSelected="embedSelected"
        :fetching="isLoading"
        :livePlayer="livePlayer"
        :liveInfo="liveInfo"
        :isPlayerLiveState="isPlayerLiveState"
        :showMenuPosition="showMenuPosition"
        :video="video"
        @start-time="startTime = $event"
        @showEmbed="(val) => (showMenuEmbed = val)"
        @embed="handleEmbedEmit"
        @playOpensFullscreen="handlePlayOpensFullscreen"
        @preloadEmbed="preloadEmbed = $event"
      />
      <duplicate-video-modal
        v-if="!isStreamingRightNow"
        :openModal="openDuplicateVideoModal"
        :videoId="videoId"
        :goToDuplicatedVideo="true"
        @close="openDuplicateVideoModal = false"
      />
      <performance-modal
        v-if="showMenuPerformance && !isPlayerLiveState"
        :video="video"
        :showMenuPerformance="showMenuPerformance"
        :showMenuPosition="showMenuPosition"
        @showPerformance="(val) => (showMenuPerformance = val)"
      />
      <v-dialog v-model="restreamDialog" max-width="700">
        <v-card v-if="!reStreamLoading && !reStreamError">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="mt-2">
            {{ $t('message.pages.newLive.reStreamDescription') }}
          </v-card-text>
          <v-row class="px-6">
            <v-col cols="4">
              <v-text-field
                v-model="newRestream.rtmp"
                :label="$t('message.pages.newLive.streamUrl')"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="newRestream.streamKey"
                :label="$t('message.pages.newLive.streamKey')"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-row class="px-4 pt-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="addRestreamLoading"
                  :disabled="
                    addRestreamLoading ||
                    newRestream.rtmp === '' ||
                    newRestream.streamKey === ''
                  "
                  @click="handleAddRestream"
                  >{{ $t('message.pages.newLive.add') }}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-col
              class="pa-0"
              v-for="restream in restreams"
              :key="restream.id"
            >
              <v-row align="center" class="px-6 py-3">
                <span class="text--secondary">{{ restream.rtmp_url }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  @click="deleteRestream(restream.rtmp_id)"
                  class="mb-1"
                  icon
                  x-small
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-row>
              <v-row class="px-6">
                <v-divider></v-divider>
              </v-row>
            </v-col>
          </v-col>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="restreamDialog = false">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="reStreamError">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            {{ reStreamError }}
          </v-card-text>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="reStreamLoading">
          <v-card-title class="text-h5">
            <v-icon class="pr-2" large color="primary">mdi-access-point</v-icon>
            {{ $t('message.pages.newLive.reStream') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-row justify="center" class="mt-9 mb-8">
            <v-progress-circular
              indeterminate
              :size="72"
              color="primary"
            ></v-progress-circular>
          </v-row>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal">
              {{ $t('message.pages.newLive.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-menu
        v-model="showMenuLink"
        max-width="450px"
        min-width="450px"
        :position-x="showMenuPosition.x"
        :position-y="showMenuPosition.y"
        absolute
        offset-y
        :close-on-content-click="false"
      >
        <v-card class="pa-7">
          <v-row no-gutters>
            <v-col cols="12" class="py-0">
              <h3 class="mb-6" style="font-weight: 500">
                {{ $t('message.pages.video.copyHLS') }}
              </h3>
              <v-text-field
                v-if="isStreamingRightNow"
                v-model="streamHls"
                outlined
                dense
                hide-details
                readonly
                label="URL Playlist HLS"
                required
                @focus="$event.target.select()"
                color="primary"
                @click:append="handleShowLink(streamHls)"
                class="mb-6"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="handleShowLink(streamHls)"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span>
                      {{
                        isCopied
                          ? $t('message.pages.videoEditModal.copied')
                          : $t('message.pages.videoEditModal.copyToClipboard')
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-text-field>

              <v-text-field
                v-else
                v-model="video.video_hls"
                outlined
                dense
                hide-details
                readonly
                label="URL Playlist HLS"
                required
                @focus="$event.target.select()"
                color="primary"
                @click:append="handleShowLink(video.video_hls)"
                class="mb-6"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="handleShowLink(video.video_hls)"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span>
                      {{
                        isCopied
                          ? $t('message.pages.videoEditModal.copied')
                          : $t('message.pages.videoEditModal.copyToClipboard')
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <a
                style="font-weight: 500; text-decoration: none"
                target="_blank"
                :href="privacyPageLink"
              >
                {{ $t('message.pages.video.privacyPage') }}
              </a>
            </v-col>
          </v-row>
        </v-card>
      </v-menu>
      <v-menu
        v-model="showMenu"
        :close-on-content-click="!bypassClickCloseMenu"
        close-on-click
        max-width="170px"
        min-width="170px"
        :position-x="showMenuPosition.x"
        :position-y="showMenuPosition.y"
        absolute
        offset-y
      >
        <v-list dense class="py-0">
          <v-list-item @click="handleMoveVideo()" v-if="!isStreamingRightNow">
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-folder-move-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('message.move') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="openDuplicateVideoModal = true"
            v-if="!isStreamingRightNow && video.status === 'CONVERTED'"
          >
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-content-duplicate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('message.duplicate') }}</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
            @click="downloadVideo()"
            v-if="!isStreamingRightNow && video.backup"
          >
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('message.download') }}</v-list-item-title>
          </v-list-item> -->
          <MenuItemDownload
            v-if="hasEditVideoPerm && !isStreamingRightNow"
            :video="video"
            :timeout="1000"
            :video-id="videoId"
            :fetch-on-mount="false"
            :value="showMenu"
            @click.native="bypassClickCloseMenu = true"
            @fetched="bypassClickCloseMenu = false"
            @submit="
              downloadServer = $event.downloadServer
              qualityToBeDownloaded = $event.qualityToBeDownloaded
              $nextTick(() => $refs.downloadForm.submit())
            "
          />
          <v-divider />
          <v-list-item @click="handleRemoveLive">
            <v-list-item-icon class="mr-3">
              <v-icon style="color: #f44336">mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: #f44336; padding-top: 3px">
              {{ $t('message.pages.video.remove') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </page-view>
</template>

<script>
/* eslint-disable */

// external imports
import { mapActions, mapMutations, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import CountDown from 'count-time-down'
import * as Sentry from '@sentry/vue'

// internal imports
import store from '@/store'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import i18n from '@/translations/lang'
import { ENV_CONFIG } from '@/config/envs'
import Storage from '@/utils/Storage'
import liveMixin from '@/utils/live.mixin.js'
import embedPageMixin from '@/utils/embedPage.mixin.js'
import introMixin from '@/utils/intro.mixin.js'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import mutedCustomMixin from '@/utils/mutedCustom.mixin.js'

// API
import videosApi from '@/services/videosApi'
import profileApi from '@/services/profileApi'

// Components
import VideoPlayer from '@/views/VideoPage/player/VideoPlayer.vue'
import LivePlayer from '@/views/VideoPage/player/LivePlayer.vue'
import LiveMetrics from '@/views/VideoPage/info/LiveMetrics.vue'
import EmbedVideo from '@/components/EmbedVideo.vue'
import PerformanceModal from '@/components/PerformanceModal.vue'
import DuplicateVideoModal from '@/components/DuplicateVideoModal.vue'
import PageView from '@/layout/PageView.vue'
import MenuItemDownload from '@/components/MenuItemDownload.vue'

export default {
  components: {
    VideoPlayer,
    LivePlayer,
    LiveMetrics,
    EmbedVideo,
    PerformanceModal,
    DuplicateVideoModal,
    PageView,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
    MenuItemDownload,
  },
  name: 'NewLive',
  directives: { mask },
  mixins: [
    liveMixin,
    embedPageMixin,
    introMixin,
    calcMegabytesMixin,
    mutedCustomMixin,
  ],
  data: () => ({
    openDuplicateVideoModal: false,
    showMenuPerformance: false,
    radioActive: 0,
    timeCounter: '',
    isTimingDown: false,
    countDown: '',
    signalLocation: i18n.t('message.serverSignal'),
    signalItems: [i18n.t('message.serverSignal'), i18n.t('message.cdnSignal')],
    serverStatus: 'offline',
    liveStatus: '',
    showMenu: false,
    showMenuEmbed: false,
    isLive: false,
    showMenuLink: false,
    menuItem: {},
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '',
    },
    startTime: '00:00:00',
    showMenuPosition: {
      x: 1920,
      y: 72,
    },
    videoEmbed: {
      currentTime: 0,
      currentTimeInSeconds: 0,
    },
    timeVideo: 0,
    valid: false,
    fetching: false,
    isLoading: true,
    oldVideo: {},
    video: {
      title: '',
      description: '',
      video_external_id: '',
      id: '',
    },
    videoId: '',
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLengthVideo'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    errors: {
      failedToUpdateVideo: false,
      videoDoesNotExist: false,
    },
    networkErrorMsg: '',
    unknownError: '',
    embedSelected: '',
    videoCustomSize: false,
    autoplay: false,
    isCopied: false,
    authToken: '',
    value: 0,
    activeInput: null,
    db: null,
    streamHls: '',
    playOpensFullscreen: false,
    playOpensFullscreenNative: false,
    preloadEmbed: true,
    introPageKey: 'live-page',
    bypassClickCloseMenu: false,
    qualityToBeDownloaded: null,
    downloadServer: '',
  }),
  provide() {
    return {
      introPageKey: this.introPageKey,
    }
  },
  async created() {
    await this.fetchData()
    if (this.videoId) {
      try {
        let videoInfo = await videosApi.getAVideo(this.videoId)
        let videoProfileId = videoInfo.data.config.profile
        if (videoProfileId) {
          let profile = await profileApi.getProfileId(videoProfileId)
          this.UPDATE_VIDEO_PROFILE(profile.data)
        }
      } catch (e) {
        console.error(e)
      }
    }

    if (!this.isStreamingRightNow) {
      await this.readVideoInfo()
    }

    this.isLoading = false
    let storageEmbedOption = Storage.getItem('embedType')
    if (!storageEmbedOption) {
      Storage.setItem('embedType', embedOptions[0].text)
      this.embedSelected = embedOptions[0].text
    }
    let pullzoneValue = Storage.getItem(
      `pullzone-${this.$store.state.user.userInfo.sub}`
    )
    this.userPullzoneName = pullzoneValue
    this.embedSelected = storageEmbedOption
    this.authToken = Storage.getItem('accessToken')
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.$root.streamUrl = this.streamUrl
    this.$root.streamHls = this.streamHls
    this.$root.streamKey = this.streamKey
  },
  async mounted() {
    this.$root.$on('changeShowLiveTitle', (value) => {
      this.showLiveTitle = value
    })

    this.$root.$on('changeShowCDN', (value) => {
      this.showCDN = value
    })

    if (this.$route.fullPath.indexOf('live') !== -1) {
      this.isLive = true
      this.isBeta = location.search.match('beta')
      clearInterval(this.checkViewers)
      if (this.serverStatus === 'online' && this.liveStatus === 'online')
        await this.fetchRestreams()
    }

    this.$root.$on('removedVideoInPage', async () => {
      await window.db.videos.delete(this.video.id)
      this.handleBackToListing()
    })

    window.addEventListener('message', (event) => {
      if (!this.profile.colors) return
      const { data } = event
      const { captionsColor, captionsBackgroundColor } = this.profile.colors

      if (data.message === 'panda_timeupdate') {
        this.videoEmbed.currentTime = Math.round(data.currentTime)
      }
      if (data.message === 'panda_ready') {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'colors',
            parameter: {
              colors: {
                primaryColor: this.profile.colors?.primaryColor,
                controlsColor: this.profile.colors?.controlsColor,
                captionsColor: captionsColor,
                captionsBackgroundColor: captionsBackgroundColor,
              },
            },
          },
          '*'
        )
        iframe.postMessage(
          {
            type: 'bookMarks',
            parameter: {
              bookMarks: this.$store.state.video.video.config?.bookMarks,
            },
          },
          '*'
        )
      }
    })

    this.setIntroJS({ key: this.introPageKey })

    this.konva.file = null
    this.konva.anima = null
    this.konva.gif = null
    this.konva.animator = null

    this.konva.id =
      this.$store.state.video.profile?.vsl?.customMutedIndicatorId || null

    this.isBrowserBrave =
      (navigator.brave && (await navigator.brave.isBrave())) || false

    if (this.isBrowserBrave) this.konva.percent = 1
  },
  beforeDestroy() {
    this.$root.$off('removedVideoInPage')
    this.UPDATE_VIDEO({})
    this.UPDATE_VIDEO_PROFILE({})
    this.UPDATE_PLAYER({})
    this.UPDATE_VIDEO_PROFILE_ID(null)
  },
  watch: {
    isStreamingRightNow(value) {
      if (!value) this.$root.$emit('changeShowLiveTitle', false)
    },
    radioActive: function () {
      this.radioActive === 1 ? (this.embedSelected = 'general') : ''
    },
    controlsColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.controlsColor = value.substr(0, 7)
      }
    },
    signalLocation(value) {
      if (value === i18n.t('message.serverSignal')) this.showCDN = false
      else if (value === i18n.t('message.cdnSignal')) this.showCDN = true
    },
    startTime: function () {
      let time = this.startTime.split(':')
      let seconds = +time[0] * 60 + +time[1]
      let input = this.startTime
      if (this.timeVideo >= 3600) {
        if (time.length === 2) {
          seconds = +time[0] * 60 + +time[1]
        } else if (time.length === 1) {
          seconds = +time[0]
        } else {
          seconds = +time[0] * 60 * 60 + +time[1] * 60 + +time[2]
        }
      } else {
        if (time.length === 1) {
          seconds = +time[0]
        }
      }
      if (seconds > this.timeVideo) {
        this.embedVideo.startTime = this.timeVideo
        this.startTime = this.formatTime(this.timeVideo, 'startTime')
      }
      this.embedVideo.startTime = seconds
    },
    liveTransmissionStatus(val) {
      if (val === 'good' || val === null) return

      if (this.liveBytesIn === 0) return

      if (this.liveKbps === null) return

      if (this.previousBytes === null || this.previousTime === null) return

      if (this.serverStatus !== 'online' || this.liveStatus !== 'online') return

      const { liveKbps, previousTime, userInfo } = this

      try {
        Sentry &&
          Sentry.captureMessage(new Error('live-kbps-error'), {
            tags: {
              live_time: `${previousTime}`,
              live_bytes_in: `${liveKbps}`,
              ...userInfo,
            },
          })
      } catch (err) {
        console.log(err)
      }
    },
  },
  computed: {
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    videoPlayerUrl() {
      if (this.isPlayerLiveState) {
        return this.livePlayer
      }

      return this.video.video_player
    },
    textMetadata() {
      return `<link rel="prerender" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/?v=${this.video.video_external_id}">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/hls.js" as="script">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/plyr.polyfilled.min.js" as="script">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/${this.video.video_external_id}.json" as="fetch">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/config.json" as="fetch">
<link rel="preload" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8" as="fetch">
<link rel="dns-prefetch" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://${this.video.pullzone_name}.b-cdn.net">`
    },
    ...mapState({
      profile: (state) => state.video.profile,
    }),
    isPlayerLiveState() {
      if (!this.videoId) {
        return true
      } else if (this.video.status !== 'CONVERTED') {
        return true
      } else {
        false
      }
    },
    isStreamingRightNow() {
      if (!this.videoId) {
        return true
      }

      this.showCDN = false
      return false
    },
    downloadUrl() {
      return `https://download.pandavideo.com:7443/videos/${this.videoId}/download`
    },
    descriptionErrMsg() {
      if (this.optionalDescription) {
        return i18n.t('message.minimumLength')
      }
      return ''
    },
    optionalDescription() {
      if (this.video.description) {
        if (this.video.description.length > 2) return false
        if (this.video.description.length === 0) return false
        return true
      } else {
        return false
      }
    },
    aspectRatio() {
      const { width, height } = this.isPlayerLiveState
        ? this.streamDetails
        : this.video
      let ratio = height / width

      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }

      return `${ratio * 100}%`
    },
    isLandscapeOrientation() {
      return parseFloat(this.aspectRatio) < 100
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))

      return [general, ...sorted]
    },
    infoPage() {
      const locale = this.getLocale()

      if (!this.video.created_at) return false

      const prefix = this.$i18next.t('message.pages.video.pageIndividualInfo')
      const created_at = new Date(this.video.created_at).toLocaleString(
        locale,
        { year: 'numeric', month: '2-digit', day: '2-digit' }
      )
      const size = this.calcMegabytes(this.video.storage_size, 'B', 'MB', true)

      return `<span>${prefix} ${created_at}</span><span class="ml-4">${size}</span>`
    },
    isDomainFromBrazil() {
      return location.host.match(/.com$/) ? false : true
    },
    privacyPageLink() {
      return `https://pandavideo.com${
        this.isDomainFromBrazil ? '.br' : ''
      }/privacy/`
    },
  },
  methods: {
    ...mapActions('video', ['getVideoConfig', 'getVideoProfileId']),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_PLAYER',
      'UPDATE_VIDEO_PROFILE_ID',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    setCounter() {
      let sec =
        (new Date().getTime() - new Date(this.liveInfo.started_at).getTime()) /
        1000
      function pad(val) {
        return val > 9 ? val : '0' + val
      }
      setInterval(
        function () {
          this.timeCounter = `(${
            pad(parseInt(sec / 60 / 60, 10)) +
            ':' +
            pad(parseInt((++sec / 60) % 60, 10)) +
            ':' +
            pad(parseInt(sec % 60, 10))
          })`
        }.bind(this),
        1000
      )
      this.isTimingDown = true
    },
    setTimeDown(time) {
      let cd = new CountDown(
        time,
        { autoStart: true },
        function () {
          this.countDown = `- ${cd.mmss}`
        }.bind(this)
      )
      cd.start()
    },
    handleShowCDN() {
      this.$root.$emit('changeShowCDN', this.showCDN)
    },
    async handleRemoveLive() {
      let liveArray = [
        {
          live_id: this.$route.params.id,
        },
      ]
      this.$root.$emit('deleteVideoModal', liveArray, 'Live')
    },
    async readVideoInfo() {
      const videoId = this.videoId
      if (this.$route.name === 'NewLive') {
        try {
          let videoInfo = await videosApi.getAVideo(videoId)
          if (videoInfo.data.status !== 'CONVERTED') {
            if (this.video.video_player !== this.livePlayer) {
              this.video = videoInfo.data
              this.oldVideo = { ...videoInfo.data }
              this.video.video_player = this.livePlayer
              this.UPDATE_VIDEO(this.video)
            }
            setTimeout(this.readVideoInfo, 10000)
          } else {
            this.video = videoInfo.data
            this.oldVideo = { ...videoInfo.data }
            if (videoInfo.data.description === null) {
              this.video.description = ''
              this.oldVideo.description = ''
            }

            this.timeVideo = this.oldVideo.length
            this.video.video_external_id = videoInfo.data.video_external_id
            if (this.video.config.profile) {
              await this.getVideoProfileId(this.video.config.profile)
            }

            this.UPDATE_VIDEO(this.video)
            this.isLoading = false
          }
        } catch (error) {
          console.error(error)
          this.isLoading = false
        }
      }
    },
    async handleEdit() {
      this.errors.failedToUpdateVideo = false
      this.networkErrorMsg = ''
      this.activeInput = ''
      let videoObj = {}
      if (this.video.title !== this.oldVideo.title) {
        videoObj['title'] = this.video.title.trim()
      } else if (this.video.description !== this.oldVideo.description) {
        videoObj['description'] = this.video.description.trim()
      } else {
        return
      }
      this.fetching = true
      if (this.videoId) {
        try {
          const apiVideo = videoObj
          let ret = await videosApi.updateVideo({ ...apiVideo }, this.videoId)
          await window.db.videos.update(ret.data.id, { title: ret.data.title })
          this.oldVideo = ret.data
          this.video.folder_id
            ? this.$root.$emit('folderEditVideo', ret.data)
            : this.$root.$emit('rootEditVideo', ret.data)
          this.handleSnackbar()
        } catch (e) {
          this.networkErrorMsg = e.response.data.errMsg
          this.errors.failedToUpdateVideo = true
        }
      }
      this.fetching = false
    },
    async handleDeleteVideo() {
      let videos = []
      videos.push(this.video)
      this.$root.$emit('deleteVideoModal', [...videos])
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    handleEmbedEmit(embed) {
      this.handleSnackbar(this.$t('message.embedCopiedLink'))
      this.handleShowLink(embed)
    },
    handlePlayOpensFullscreen({ script, native }) {
      this.playOpensFullscreen = script
      this.playOpensFullscreenNative = native
    },
    inputBeingEdited(i, ref) {
      this.activeInput = i
      if (ref) {
        this.activeInput = i + ref
      }
    },
    inputEndEdited() {
      this.activeInput = ''
    },
    cancelEdit() {
      if (this.video.title !== this.oldVideo.title) {
        this.video.title = this.oldVideo.title
        this.$refs.title.blur()
      } else if (this.video.description !== this.oldVideo.description) {
        this.video.description = this.oldVideo.description
        this.$refs.description.blur()
      }
    },
    getRecuoModal(size) {
      const innerWindowWidth = window.innerWidth
      let recuo = innerWindowWidth - size

      if (recuo < 0) recuo = 0

      return recuo
    },
    showDots() {
      this.showMenuPosition.x = this.getRecuoModal(150)

      this.showMenu = false
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    showEmbed() {
      this.showMenuPosition.x = this.getRecuoModal(600)

      this.showMenuEmbed = false
      this.$nextTick(() => {
        this.showMenuEmbed = true
      })
    },
    handleInput(event) {
      if (!this.bypassClickCloseMenu) {
        this.showMenu = event
      }
    },
    showPerformance() {
      this.showMenuPosition.x = this.getRecuoModal(600)

      this.showMenuPerformance = false
      this.$nextTick(() => {
        this.showMenuPerformance = true
      })
    },
    showLink() {
      this.showMenuPosition.x = this.getRecuoModal(450)

      this.$nextTick(() => {
        this.showMenuLink = true
      })
    },
    formatTime(seconds, type) {
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.round(seconds % 60)
      if (type) {
        0
        if (this.timeVideo >= 3600) {
          return [
            h > 9 ? h : h ? '0' + h : '0' + h || '00',
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        } else {
          return [
            m > 9 ? m : h ? '0' + m : '0' + m || '00',
            s > 9 ? s : '0' + s,
          ]
            .filter(Boolean)
            .join(':')
        }
      }
      return [
        h > 9 ? h : h ? '0' + h : '0' + h || '00',
        m > 9 ? m : h ? '0' + m : '0' + m || '00',
        s > 9 ? s : '0' + s,
      ]
        .filter(Boolean)
        .join(':')
    },
    async downloadVideo() {
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      this.$refs.downloadForm.submit()
    },
    handleMoveVideo() {
      this.$root.$emit('moveModal', [this.$store.state.user.routedVideo])
    },
    handleRemoveItem() {
      this.$root.$emit('deleteVideoModal', [this.$store.state.user.routedVideo])
    },
    hasHistory() {
      return window.history.length > 2
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
    handleCopyContent(value) {
      navigator.clipboard.writeText(`${value}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_live';

.konva {
  &__container {
    position: relative;
  }

  &__stage {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    width: 100%;
    height: 100%;
  }

  &__player {
    pointer-events: none;
  }
}
</style>

<style>
.container-title-description .v-text-field--outlined fieldset,
.container-title-description .v-input__slot .v-input__append-inner {
  display: none;
}

.container-title-description .inputActive fieldset,
.inputActive .v-input__slot .v-input__append-inner,
.inputActive .v-textarea .v-input__append-inner {
  display: block !important;
}

.container-title-description .v-input__slot:hover {
  background: #3e50f740 !important;
}

.container-title-description
  .inputActive
  .v-input__control
  .v-input__slot:hover {
  background: transparent !important;
}

.container-title-description .v-text-field input {
  font-size: 1.2em;
  font-weight: 500;
}

.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.embed-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

.defaultThumb {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.headerTitle {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.08em;
}

.cardTitle {
  font-weight: 600;
  font-size: 28px;
  line-height: 150%;
}

.embed-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

@media only screen and (max-width: 767px) {
  .live-info {
    position: absolute;
    margin-top: 53px;
  }
  .second-col{
  max-width: 100%; flex: 0 0 100%; padding-top: 5px;
}
.primary-col{
  max-width: 100%; flex: 0 0 100%; margin-left: 12px;
}
}

.cardSubtitle {
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.08em;
  color: #878787;
}

.icon-container {
  background-color: #eaedf6;
  padding: 4px;
  border-radius: 3px;
}

.videoCardTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #2f2f2f;
}

.cardElevation {
  box-shadow: 0px 5px 20px rgba(18, 25, 43, 0.06) !important;
  border-radius: 20px !important;
}

.wrapText {
  word-break: break-word;
}

.menuText {
  font-weight: 400;
  margin: 0 0 0 5px !important;
  letter-spacing: normal;
  font-family: 'Rubik', sans-serif !important;
  padding: 2px 0;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #ffffff;

  position: absolute;
  right: 40px;
  left: var(--triangle-recuo);
  top: 58px;
  z-index: 8;

  -webkit-filter: drop-shadow(1px -4px 2px rgba(0, 0, 0, 0.04));
  filter: drop-shadow(1px -4px 2px rgba(0, 0, 0, 0.04));
}
.triangle.link {
  right: 396px;
}
.triangle.embed {
  right: 303px;
}
.triangle.performance {
  right: 165px;
}

.triangle.link.while-live {
  right: 280px;
}
.triangle.embed.while-live {
  right: 190px;
}
.triangle.performance.while-live {
  right: 165px;
}

.bottom-navigation-playerConfig
  .v-item-group.v-bottom-navigation
  .v-btn.v-btn--active {
  border-bottom: 2px solid #6366f7;
}

.icon-accordion {
  order: 0;
}

.header-accordion {
  order: 1;
}

:root {
  --plyr-color-main: #fafafa;
  --plyr-captions-text-color: #fafafa;
  --plyr-captions-background: #fafafa;
  --plyr-video-control-color: #fafafa;
  --plyr-captions-text-color: #fafafa;
}

.button-choose-cta {
  width: 100%;
}

.button-choose-cta span {
  width: 100%;
  float: left;
  text-align: left;
  display: block;
}

.button-choose-cta span i {
  float: right;
}

.v-alert__wrapper i {
  align-self: center;
}

.circle {
  margin-right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
}

.performance-textarea .v-text-field__slot {
  margin: 0 -47px 4px 0 !important;
}

.no-border .v-input__control .v-input__slot::after,
.no-border .v-input__control .v-input__slot::before {
  display: none !important;
}

@keyframes provisioning {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
